import lab from "./lab.svelte";
import home from "./home.svelte";
export default {
    "/": home,
    "/lab": lab,
    // "*": RouteNotFound,
};
